export enum EButtonStyleType {
  GENERAL_FORM = 'GENERAL_FORM',
  PURPLE = 'PURPLE',
  PURPLE_TRANSPARENT = 'PURPLE_TRANSPARENT',
  OUTLINE_PURPLE = 'OUTLINE_PURPLE',
  DANGER = 'DANGER',
  DANGER_TRANSPARENT = 'DANGER_TRANSPARENT',
}
